import { render } from "./DaneModal.vue?vue&type=template&id=439e9556"
import script from "./DaneModal.vue?vue&type=script&lang=js"
export * from "./DaneModal.vue?vue&type=script&lang=js"
script.render = render

export default script